import styled from 'styled-components';

// Modal
export const ModalWrapper = styled.section<{
    opened: boolean;
}>`
    display: ${({ opened }) => (opened ? 'block' : 'none')};
    height: calc(100% - var(--desktop-footer-height));
    padding: 12px;
    width: 320px;

    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;

    @media screen and (max-width: 480px) {
        box-sizing: border-box;
        height: 100%;
        padding: 0;
        width: 100%;
    }

    @media screen and (max-width: 991px) and (orientation: landscape) {
        box-sizing: border-box;
        height: 100%;
    }
`;

export const ModalContainer = styled.div`
    background-color: ${({ theme }) => theme.root.colors.background.sheetOrModal};
    box-shadow: rgba(0, 0, 0, 0.24) 0 16px 24px;
    border-radius: 16px;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media screen and (max-width: 480px) {
        border-radius: 0;
    }
`;

export const ModalHeader = styled.header`
    box-sizing: border-box;
    min-height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ModalHeaderContent = styled.div`
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    padding-left: 16px;
`;

export const ModalClose = styled.button`
    background: none;
    border: 0;
    cursor: pointer;
    line-height: 0;
    margin-right: 10px;
    margin-left: 10px;

    svg path {
        fill: ${(props) => props.theme.root.colors.basicColors['55%']};
    }

    &:hover svg path {
        fill: ${(props) => props.theme.root.colors.basicColors['90%']};
    }
`;

export const ModalBody = styled.section`
    height: 100%;
    overflow-y: auto;
`;

export const ModalFooter = styled.section`
    justify-self: flex-end;
    margin-top: auto;
    padding: 12px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: relative;
    flex-shrink: 0;
`;
